import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { Button as DsButton } from "../../../design-system/components/primitives/Button/Button";

export const EmbedTitle = styled.h2`
  margin: 0;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const EmbedBodyPad = styled.div`
  padding: ${spacing[4]} ${spacing[4]};
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;

export const EmbedStatusText = styled.p`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const EmbedErrorText = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.accent.red500};
`;

export const EmbedNote = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const FooterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing[3]};
  padding: ${spacing[3]} ${spacing[4]};
`;

export const CancelBtn = styled(DsButton)`
  &&& {
    width: 152px;
    min-width: 152px;
    height: 40px;
  }
`;

export const CopyBtn = styled(DsButton)`
  &&& {
    width: 152px;
    min-width: 152px;
    height: 40px;
  }
`;

/** A full-width line above the buttons, so it fits at any width. */
export const CopyReason = styled.span`
  order: -1;
  flex-basis: 100%;
  text-align: right;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;
